import SearchBox from "./SearchBox";
import "./Style.scss";

export { SearchBox };
